/**
 * Notification Service
 * Handles notification-related API calls
 */

import { apiClient } from "../client";
import type { NotificationCountResponse } from "../types";

export const notificationService = {
  /**
   * Get notification counts (orders and receipts)
   * Endpoint: DirectorModule/notification-count
   */
  async getNotificationCount(firmId: number): Promise<NotificationCountResponse> {
    const response = await apiClient.get<NotificationCountResponse>(
      "DirectorModule/notification-count",
      { firmId }
    );
    return response.data;
  },

  /**
   * Mark notifications as read
   * Endpoint: DirectorModule/notification-read
   * @param firmId - Firm ID
   * @param mode - Mode 1 for Orders, Mode 2 for Receipts
   */
  async markNotificationsAsRead(firmId: number, mode: 1 | 2): Promise<void> {
    const endpoint = `DirectorModule/notification-read?firmId=${firmId}&mode=${mode}`;
    await apiClient.post(endpoint, {});
  },
};

